// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAkbtc } from "../../../icons/full/build/icon-akbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AkbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAkbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AkbtcIcon.displayName = 'AkbtcIcon';
}

export default AkbtcIcon;